export default (initialState = {}) => {
  return () => {
    return {
      type: [],
      recipient_id: null,
      name: "",
      phone: "",
      email: "",
      is_custom: false,
      ...initialState,
    };
  };
};
